export default __webpack_public_path__ + "static/media/product001.a472d735.jpg";